import { default as SearchInput } from './search-input'

export default SearchInput
